<template>
  <div id="extra-data-for-company">

    <memlist-text-input
      v-model="local_item.value"
      :title="extra_data.name"
      @input="change_data"
      type="text"
    />

  </div>
</template>


<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'ExtraDataForCompanyComponent',
  components: {
    
  },
  mixins: [ toasts ],
  props: ['company_id', 'extra_data', 'extra_rows'],
  emits: ['saved', 'change'],
  computed: {
    
    ...mapGetters(['currentPeriodId', 'currentCompanyId', 'companies']),
    
  },
  mounted() {

  },
  data() {
    return {
      local_item: {
        value: null
      },
    };
  },
  watch: {
    extra_data: {
      deep: true,
      handler(val) {
        this.setup_local_value();
      },
      immediate: true
    },
    extra_rows: {
      deep: true,
      handler(val) {
        this.setup_local_value();
      },
      immediate: true
    },
    
  },
  methods: {

    setup_local_value() {
      if (!this.extra_data) {
        return;
      }

      if (!this.extra_rows) {
        return;
      }

      const item = this.extra_rows.find(i => i.extra_id === this.extra_data.id);

      if (item) {
        this.local_item = { ...item };
      }
      else {
        this.local_item = {
          company_id: this.company_id,
          extra_id: this.extra_data.id,
        }
      }
    },

    change_data() {

      if (!this.local_item) {
        this.local_item = {};
      }
      
      this.local_item.extra_id = this.extra_data.id;
      this.local_item.company_id = this.company_id;

      console.log('extra data changing', this.local_item);
      this.$emit('change', this.local_item);
    },

  }
};
</script>
